// extracted by mini-css-extract-plugin
module.exports = {"avatarContainer":"avatarContainer__33m78","avatar":"avatar__1seNw"};